export default "__VITE_ASSET__C_hfTbdD__"